// extracted by mini-css-extract-plugin
module.exports = {"container":"with_gradient_layout-module--container--20xri"};